import { tracker } from 'src/utils/analytics';

export type IdleWarningAction = 'continued' | 'expired' | 'shown';

/**
 * Idle-warning analytics: the false-reset-rate and abandonment metrics for the
 * kiosk concierge. Its own event rather than an impression/action pair, because
 * a host-rendered chrome warning has neither a transcript turn nor an in-chat
 * placement to report.
 *
 * The conversation id is the one the remote stores, and is omitted when unknown.
 * Failures are swallowed — an analytics rejection must never interfere with a
 * session reset.
 */
export function trackIdleWarning(
  action: IdleWarningAction,
  { conversationId }: { conversationId: string | null }
): void {
  try {
    tracker.conciergeIdleWarning(conversationId ? { action, conversationId } : { action });
  } catch {
    /* analytics must never block session hygiene */
  }
}
